import React, { Component } from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Paper from "material-ui/Paper";
import ReactMarkdown from "react-markdown";
import Flow from "./Flow";
import StateChanger from "./StateChangerOld";
import SpecText from "./SpecText";
import UiComp from "./UiComp";

class StatePreview extends Component {
  constructor(props) {
    super(props);

    this.state = { expanded: false };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    if (!this.props.state) return "";
    var that = this;
    let images;
    if (this.props.state.images)
      images = this.props.state.images.map(image => {
        return (
          <div
            style={{ maxHeight: 300, overflow: "hidden", position: "relative" }}
          >
            <img src={image} style={{ width: 180, height: "auto" }} />
          </div>
        );
      });
    else images = "";
    return (
      <div>
        <div style={{ padding: 6, background: "#ccff00" }}>
          <span style={{ fontSize: 14 }}>{this.props.state.title}</span>
        </div>
        <br />
        &nbsp;
        {images}
      </div>
    );
  }
}

export default StatePreview;



// WEBPACK FOOTER //
// ./src/components/StatePreview.js